module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Brett Colasacco, Willemien Otten, W. Clark Gilpin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("  "), _c('B', [_vm._v("Brett Colasacco")]), _vm._v(" is the former editor of "), _c('I', [_vm._v("Sightings: Religion in Public Life")]), _vm._v(", a twice-weekly publication of the Martin Marty Center for the Public Understanding of Religion. He has a PhD in religion, literature, and visual culture from the University of Chicago where he currently works as a writer."), _c('BR'), _vm._v("  ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15SSeRh/images/cover.jpg?1684988648503",
      "alt": "This image is the cover for the book Sightings"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sightings\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("For the past twenty years, Martin Marty and the editors of "), _c('i', [_vm._v("Sightings")]), _vm._v(", a digital publication of the University of Chicago Divinity School’s Martin Marty Center, have published informed, accessible, and witty commentary on religion in current events. Featuring more than seventy authors—including Marty himself, Eboo Patel, and Krista Tippett—this book collects one hundred of the best essays that originally appeared in "), _c('i', [_vm._v("Sightings")]), _vm._v(".")]), _c('p', [_vm._v("Religion in public life fluctuates in temperature, but in the last twenty years, the religious climate has produced some harsh and extreme conditions that make the need for public discussion and understanding of religion more vital than ever. In this volume writers intelligently engage and elucidate many critical trends, issues, and practices of faith in our pluralistic world. Rich food for thought awaits readers here.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0